var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-5 text-center"},[_c('h4',[_vm._v("Something went wrong.")]),_c('h5',[_vm._v(" You are not authorized to access this portal. Please contact at "),_c('a',{staticClass:"theme-font-bold",attrs:{"href":"mailto:support@esolutionsgroup.ca"}},[_vm._v(" support@esolutionsgroup.ca")])])])
}]

export { render, staticRenderFns }